import { GET_MARKETS } from '../actionTypes'
import { Market } from '../reducers/market'

export const getMarketsAction = (markets: Market[]) => ({ type: GET_MARKETS, payload: markets })
